// Checks if display mode is in standalone or fullscreen
export const isPWA = () =>
  window.matchMedia("(display-mode: fullscreen)").matches &&
  window.innerWidth < 500
// window.navigator.standalone
// window.matchMedia("(display-mode: fullscreen)").matches
// window.navigator.fullscreen ||
// document.referrer.includes("android-app://")



// WEBPACK FOOTER //
// ./src/utils/isPWA.js